import {
    Box,
    Paper,
    Button,
    TableContainer,
} from "@mui/material";
import { useState, useEffect, useRef, useCallback } from 'react';
import { DataGridPro, GridActionsCellItem, GridRowModes, useGridApiRef, GridToolbarQuickFilter } from '@mui/x-data-grid-pro';
import '../DispatchStyle.css'
import CustomColumnMenu from "./CustomColumnMenu";
import { useDispatchContext } from "../dispatchContext";

export default function CommonTable(props) {
    const { rowData, tableColumns, isLoading, tabletype } = props
    const { dispatchUnsavedChangesRef, setHasUnsavedRows, setUpdateTrigger } = useDispatchContext();
    /**
     * updated on 06-oct-2023
     * handle column resizing
     */
    const apiRef = useGridApiRef();
    /**
     * ENd
     */
    useEffect(() => {
        apiRef.current.autosizeColumns({
            includeHeaders: false,
            includeOutliers: true
        })
    }, [rowData])

    const QuickSearchToolbar = () => {
        return (
            <Box
                sx={{
                    p: 0.5,
                    pb: 0,
                    display: "flex",
                    justifyContent: 'flex-end',

                }}
            >
                <GridToolbarQuickFilter
                    sx={{
                        marginTop: "-75px",
                        '& input': {
                            color: 'antiquewhite'
                        },
                        '& .MuiSvgIcon-root': {
                            color: 'white', // Text color
                        },
                        '& .MuiButtonBase-root:after': {
                            color: 'antiquewhite'
                        }
                    }}
                />
            </Box>
        );
    }

    const handleKeyDown = (params, event) => {
        if (event.key === 'Tab') {
            event.preventDefault();
            moveFocusToNextColumn(params);
        }
    }

    const moveFocusToNextColumn = (params) => {
        let currentColumnIndex = tableColumns.findIndex((col) => col.field === params.field);
        let nextColumnIndex = currentColumnIndex + 1;

        // Find the next visible column
        while (nextColumnIndex < tableColumns.length && tableColumns[nextColumnIndex].hide) {
            nextColumnIndex++;
        }

        // Wrap around to the first visible column if needed
        if (nextColumnIndex >= tableColumns.length) {
            nextColumnIndex = 0;
            while (nextColumnIndex < tableColumns.length && tableColumns[nextColumnIndex].hide) {
                nextColumnIndex++;
            }
        }

        if (nextColumnIndex < tableColumns.length) {
            const nextColumnField = tableColumns[nextColumnIndex].field;
            apiRef.current.setCellFocus(params.id, nextColumnField);
        }
    };

    /**
     * Update apiRef for edited fields
     * @param {*} newRow 
     * @param {*} oldRow 
     * @returns 
     */    

    const processRowUpdate = (newRow, oldRow) => {
        if (JSON.stringify(newRow) === JSON.stringify(oldRow)) return oldRow; // No change, return old row    
        const { id: rowId } = newRow;    
        dispatchUnsavedChangesRef.current.unsavedRows[rowId] = newRow;    
        
        if (!dispatchUnsavedChangesRef.current.rowsBeforeChange[rowId]) {
            dispatchUnsavedChangesRef.current.rowsBeforeChange[rowId] = oldRow;
        }        
        setHasUnsavedRows(true);
        setUpdateTrigger((prev) => prev + 1); // Notifies all components that need an update including parent    
        
        return newRow;
    };

    return (
 <DataGridPro
            rows={rowData}
            columns={tableColumns}
            editMode="cell"
            processRowUpdate={processRowUpdate}
            columnHeaderHeight={30}
            rowHeight={30}
            checkboxSelection={false}
            //disableRowSelectionOnClick {...row}
            hideFooter={true}
            hideFooterRowCount={true}
            loading={isLoading}
            slots={{
                columnMenu: CustomColumnMenu,
                toolbar: QuickSearchToolbar
            }}
            // disableDensitySelector
            // disableColumnFilter
            // disableColumnSelector
            // slotProps={{
            //     toolbar: {
            //         showQuickFilter: true,
            //     },
            // }}
            
            // getRowClassName={(params) => {
            //     if(params.row?.arriveTruckStatus && params.row?.arriveTruckStatus != 'C' && tabletype == 'spotted'){
            //         return 'highLightWithYellow';
            //     }
            // }}
            getCellClassName={(params) => {
                let classNames = [];
           
                if (params.row?.arriveTruckStatus && params.row?.arriveTruckStatus != 'C' && tabletype == 'spotted') {
                    classNames.push('highLightWithYellow');
                }
                if (params.row?.isPastStop === 'yes' && params?.field === "apptDateTime") {
                    classNames.push('highLightWithRed');
                    return classNames.join(' ');
                }
                if (params.row?.spec === "HAZMAT" && params?.field === "spec") {
                    classNames.push('highLightWithRed');
                    return classNames.join(' ');
                }
                if (params.row?.isLfdCutOld === 'yes' && params?.field === "lfdcut") { //  && params.row?.stop?.split('/')?.[1] <= 1
                    classNames.push('highLightWithRed');
                    return classNames.join(' ');
                }
           
                return classNames.join(' ');
                
            }}
            apiRef={apiRef}
            sortingOrder={['desc', 'asc']}
            onCellKeyDown={handleKeyDown}
        />
    )
}

